import pako from 'pako';
import { Construction } from '@/app/domain/constructionStoreInterface';

export const decodeUrl = (url: string): Construction => {
    const binaryStringBase64Encode: string = atob(decodeURIComponent(url));
    return JSON.parse(pako.inflate(binaryStringBase64Encode, { to: 'string' }));
};

export const encodeUrl = (construction: Construction): string => {
    const jsonAsString: string = JSON.stringify(construction);
    const binaryString: string = pako.deflate(jsonAsString, { to: 'string' });
    const binaryStringBase64: string = btoa(binaryString);
    return encodeURIComponent(binaryStringBase64);
};

export const getBaseUrl = (): string => location.href.split('page/internal')[0] + 'page/internal';
